import { render } from "./AgentOrderListView.vue?vue&type=template&id=564538c7&scoped=true"
import script from "./AgentOrderListView.vue?vue&type=script&lang=js"
export * from "./AgentOrderListView.vue?vue&type=script&lang=js"

import "./AgentOrderListView.vue?vue&type=style&index=0&id=564538c7&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564538c7"]])

export default __exports__